import { render } from "./Auditories.vue?vue&type=template&id=ddaf7f86"
import script from "./Auditories.vue?vue&type=script&lang=js"
export * from "./Auditories.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Auditories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddaf7f86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddaf7f86', __exports__)) {
    api.reload('ddaf7f86', __exports__)
  }
  
  module.hot.accept("./Auditories.vue?vue&type=template&id=ddaf7f86", () => {
    api.rerender('ddaf7f86', render)
  })

}


export default __exports__